export class MainCtrl {
    constructor () {}
}

export class TopBarCtrl {
    constructor ($state, $window, AuthService, ReactBridge) {
        "ngInject";
        this.AuthService = AuthService;
        this.ReactBridge = ReactBridge;
        this.$state = $state;
        this.$window = $window;
    }

    get $user() {
        return this.ReactBridge().store.getState().currentUser || {};
    }

    logout() {
        this.AuthService.logout();
        if (window.ReactBridge) {
            window.ReactBridge.store.getState().setCurrentUser(null);
        }
        this.$window.location = '/';
    }
}



// WEBPACK FOOTER //
// ./src/app/ctrls.js